export default __webpack_public_path__ + "static/media/persona-logo.b0c57b8a.svg";